module.exports = __webpack_public_path__ + "static/img/guy.cd531e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guy.png
// module id = eOwC
// module chunks = 1